import React from 'react'
import Button from 'react-bootstrap/Button'
import { withPrefix } from 'gatsby'
import { Worker, Viewer, SpecialZoomLevel, DocumentLoadEvent  } from '@react-pdf-viewer/core'
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { faPlus, faMinus, faAngleLeft, faAngleRight, faFileDownload,faPrint } from '@fortawesome/free-solid-svg-icons'
import { toolbarPlugin, ToolbarSlot } from '@react-pdf-viewer/toolbar'
import { bookmarkPlugin } from '@react-pdf-viewer/bookmark'
import '@react-pdf-viewer/bookmark/lib/styles/index.css'
import { RenderGoToPageProps } from '@react-pdf-viewer/page-navigation'
import { RenderCurrentScaleProps, RenderZoomInProps, RenderZoomOutProps } from '@react-pdf-viewer/zoom'
import '../../../node_modules/@react-pdf-viewer/core/lib/styles/index.css'
import '../../../node_modules/@react-pdf-viewer/default-layout/lib/styles/index.css'
import './PdfViewer.css'

export default function PdfViewer({doc}) {
  //custom toolbar
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const bookmarkPluginInstance = bookmarkPlugin();
  const { Bookmarks } = bookmarkPluginInstance; 
 // .rpv-bookmark__empty
  //use local pdf for testing on local host; guide is longer and has bookmarks
  //let filepath = withPrefix("/Women_NVLegislature.pdf");
  //let filepath = withPrefix("/GuideToTheLegislature2021-2022.pdf");
  let filepath = "https://www.leg.state.nv.us" + doc.data.content_item_path; 
  let totalPages = 0;
  let showBookmarkPanel = true;

  const handleDocumentLoad = (e: DocumentLoadEvent) => {
    totalPages == e.doc.numPages;
    if(totalPages <= 2){
      showBookmarkPanel = false;
    }
  };
  
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.7.570/build/pdf.worker.min.js"> 
      <div className="outer-wrapper d-flex flex-column" style={{
                  border: '1px solid rgba(0, 0, 0, 0.3)',
                  height: '100%',
            
      }}>

        <div className="toolbar-wrapper d-flex justify-content-center"
        style={{
                      backgroundColor: 'var(--bs-dark)',
                      color: 'var(--background-base)',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                      padding: '4px',
                  }}>
        <Toolbar>
      {
          (slots: ToolbarSlot) => {
              const {
                  CurrentPageInput, CurrentScale, GoToNextPage, GoToPreviousPage,
                  NumberOfPages, ZoomIn, ZoomOut, Download, Print
              } = slots;
              
              return (
                  <>
                    <div className="zoom">
                      <ZoomOut>
                        {
                          (props: RenderZoomOutProps) => (
                              <Button
                                variant="dark"
                                onClick={props.onClick}
                              >
                                <FontAwesomeIcon icon={faMinus}/>
                                <div className="sr-only">Zoom out</div>
                              </Button>
                          )
                        }
                      </ZoomOut>
                      <CurrentScale>
                        {
                          (props: RenderCurrentScaleProps) => (
                            <span className="align-self-center">{`${Math.round(props.scale * 100)}%`}</span>
                          )
                        }
                      </CurrentScale>
                      <ZoomIn>
                        {
                          (props: RenderZoomInProps) => (
                            <Button
                              variant="dark"
                              onClick={props.onClick}
                            >
                              <FontAwesomeIcon icon={faPlus}/>
                              <div className="sr-only">Zoom in</div>
                            </Button>
                          )
                        }
                      </ZoomIn>
                    </div>
                    <div className="page-navigation m-auto">
                      <GoToPreviousPage>
                            {
                                (props: RenderGoToPageProps) => (
                                    <Button
                                      variant="dark"
                                      disabled={props.isDisabled}
                                      onClick={props.onClick}
                                    >
                                      <FontAwesomeIcon icon={faAngleLeft}/>
                                      <div className="sr-only">Previous page</div>
                                    </Button>
                                )
                            }
                      </GoToPreviousPage>
                      <CurrentPageInput />
                      / <NumberOfPages />
                      <GoToNextPage>
                            {
                                (props: RenderGoToPageProps) => (
                                    <Button
                                    variant="dark"
                                        disabled={props.isDisabled}
                                        onClick={props.onClick}
                                    >
                                        <FontAwesomeIcon icon={faAngleRight}/>
                                      <div className="sr-only">Next page</div>
                                    </Button>
                                )
                            }
                      </GoToNextPage>
                    </div>
                    <div className="download-and-print">
                        <Download>
                          {
                            (props) => (
                              <Button
                                  variant="dark"
                                      onClick={props.onClick}
                                  >
                                <FontAwesomeIcon icon={faFileDownload}/>
                                    <div className="sr-only">Download this document</div>
                              </Button>
                            )
                            
                          }
                        </Download>
                        <Print>
                          {
                            (props) => (
                              <Button variant="dark"
                              onClick={props.onClick}>
                                  <FontAwesomeIcon icon={faPrint}/>
                                    <div className="sr-only">Print this document</div>
                              </Button>
                            )
                          }
                        </Print>
                      </div>
                  </>
                  
              )
          }
      }
      </Toolbar>
        </div>  
        <div id="bookmark_viewer-wrapper" className="d-flex">
            <div id="bookmarks" className="d-none d-lg-block">
              <Bookmarks />
            </div>
          <div id="viewer">
            <Viewer 
            fileUrl={filepath}
            defaultScale={SpecialZoomLevel.PageFit}
            onDocumentLoad={handleDocumentLoad}
            plugins={[
              toolbarPluginInstance,
              bookmarkPluginInstance          
            ]}
            />
          </div>
        </div>
    </div>
    </Worker>
  )
}
